// Third-party imports
import Velocity from 'velocity-animate';
import 'velocity-animate/velocity.ui';

// Module name
export const MODULE_NAME = 'feature_slider';

export let global_vars = {};

export function initialize(global) {
    init_slider_click_handler(global);
    init_slider_link_handler(global);
}

function init_slider_click_handler(global) {
    let all_trigger = global.document.querySelectorAll(
        '.featureSlider-trigger'
    );
    for (let trigger of all_trigger) {
        trigger.addEventListener('click', event => {
            slider_click_handler(event, all_trigger);
        });
    }
}

function init_slider_link_handler(global) {
    let all_links = global.document.querySelectorAll(
        '.featureSlider .iconBlock-link'
    );
    for (let link of all_links) {
        link.addEventListener('click', event => {
            event.preventDefault();
        });
    }
}

function slider_click_handler(event, all_triggers) {
    event.preventDefault();
    let cur_elem = event.currentTarget;
    let cur_elem_index = 0;
    let found_cur_elem = false;

    let container = cur_elem.closest('.featureSlider');
    // let all_triggers = container.querySelectorAll('.featureSlider-trigger');
    for (let trigger of all_triggers) {
        if (trigger === cur_elem) {
            found_cur_elem = true;
            continue;
        }

        // Hide open div
        let iconblock = trigger.querySelector('.iconBlock-innerWrapper');
        Velocity(iconblock, 'slideUp', { duration: 250 });

        // remove active class from trigger
        trigger.classList.remove('featureSlider-trigger--active');

        if (!found_cur_elem) {
            cur_elem_index += 1;
        }
    }

    // toggle class to current trigger
    cur_elem.classList.toggle('featureSlider-trigger--active');

    // toggle the hidden block
    let iconblock = cur_elem.querySelector('.iconBlock-innerWrapper');
    Velocity(iconblock, 'slideUp', { duration: 250 });

    // Slide down if element is not visible, slide up if the element is visible
    let slide_type = iconblock.offsetParent === null ? 'slideDown' : 'slideUp';
    Velocity(iconblock, slide_type, { duration: 250 });

    // scroll to correct slide
    let slides = container.querySelector('.featureSlider-slides');
    let slide = slides.querySelector('.featureSlider-slide');
    let offset = slide.clientHeight * cur_elem_index;
    Velocity(slides, { marginTop: `${-offset}px` }, { duration: 50 });
}
